import type { DraftView, StepName } from '../services/recipeDraftApi';

/**
 * Which steps a user can open, computed from the server's draft. Replaces the stored flags in the old workflow
 * slice: nothing here is stored, so it cannot disagree with the draft.
 */

export interface StepAccess {
  open: boolean;
  /** Why the step is closed, or what to do when it is open but needs attention. */
  reason: string | null;
  /** The user confirmed this step. */
  done: boolean;
}

const ORDER: StepName[] = ['WATER', 'CROP', 'SALTS', 'RECIPE', 'RESULTS'];
const LABEL: Record<StepName, string> = {
  WATER: 'Water', CROP: 'Crop', SALTS: 'Salts', RECIPE: 'Recipe', RESULTS: 'Results',
};

export function stepAccess(draft: DraftView | null): Record<StepName, StepAccess> {
  const out = {} as Record<StepName, StepAccess>;
  ORDER.forEach((step, i) => {
    const own = draft?.steps[step].status;
    const done = own === 'CONFIRMED';
    if (i === 0) {
      out[step] = { open: true, reason: own === 'STALE' ? 'Changed upstream — check it again' : null, done };
      return;
    }
    const previous = ORDER[i - 1];
    if (draft?.steps[previous].status !== 'CONFIRMED') {
      out[step] = { open: false, reason: `Confirm ${LABEL[previous]} first`, done };
      return;
    }
    out[step] = { open: true, reason: own === 'STALE' ? 'Changed upstream — check it again' : null, done };
  });
  return out;
}
